module.exports = __webpack_public_path__ + "img/2892402-57-011.a30be999.png";